module.exports = __webpack_public_path__ + "static/media/ugrant-tick.50113e4f.svg";